export const apiVersion = 'v1'
export const actualSchemaVersion = '2.0.0'
export const uiVersion = '1.1.0.4'
